<template>
    <div class="box">
        <div class="top" @click="backPage">
            <img src="../../assets/images/wap/goback.png" alt="">
            <span>我的晒单</span>

        </div>
        <div class="noData" v-if="printList.length < 1">
            <img src="../../assets/images/gifts/noData.png" alt="">
            <span>暂无晒单记录</span>
        </div>
        <div class="lists" v-else>
            <div class="item" v-for="(item, i) in printList" :key="i">
                <div class="top">
                    <img class="avatar" src="../../assets/images/wap/avatar.png" alt="">
                    <span>{{ item.name }}</span>
                </div>
                <span class="times">{{ item.timeDescribe }}</span>
                <div class="content">
                    <span class="name">{{ item.content||'' }}</span>
                   
                </div>
                <div class="flex">
                    <div v-for="(items, index) in item.imgUrls" :key="index">
                        <img :src="items" alt="" class="imgs">
                    </div>
                </div>
                <div class="bottoms">
                    <span class="type"></span>
                    <div class="like" @click="addLIke(item)">
                        <img src="../../assets/images/gifts/like.png" alt="">
                        <span>{{ item.encouragements }}</span>
                    </div>
                </div>
            </div>

        </div>


    </div>
</template>

<script>
import { GetPrintOutViewPage,SetPrintOut} from '../../api/home'

export default {
    name: 'giftHistory',
    data() {
        return {
            printList: [
               
            ],
            
        }
    },
    created() {
            console.log('登录信息----',this.$store.state.login.userInfo)

        // 传给App.vue,不展示tabbar
        this.$emit('controlShow', true);
        this.getLists()
    },
    computed: {
        // 个人信息
        userInfo() {
            return this.$store.state.login.userInfo
        },
    },
    methods: {
        // 返回直播间
        backPage() {
            // this.$router.push({
            //     name: 'classRoomWap'
            // })
            this.$store.commit('home/set_showmyPrint', false)

        },
        // 获取我的晒单列表
    getLists(){
           const option = {
        
         "businessPlatform":4,
         "questionType":3,
         "account":this.userInfo.mtaccr,
     
        
         "maxResultCount":20,
         "skipCount":0
      }
      GetPrintOutViewPage(option).then(res=>{
        console.log('晒单数据----------',res)
        if(res.success){
            let list =res.result.items
           
          this.printList=res.result.items
          
        }
      }).catch(err=>{
        console.log(err);
      })
    },

    // 点赞取消点赞
    addLIke(e){
      const option={
         "businessPlatform": 4,
          "account": this.userInfo.mtaccr,
         "name": e.name,
         "printOutId": e.id
      }
      SetPrintOut(option).then(res=>{
        if(res.result.code===0){
           this.$message({
               message: res.result.message,
            type: "success",
          });
          this.getLists()
        }else{
           this.$message({
               message: res.result.message,
            type: "error",
          });
        }
      })

    },

    }
}
</script>

<style lang="less" scoped>
.box {
    width: 100%;

    background: #fff;

    height: 100%;

    .top {
        height: 45px;
        background-color: #fff;
        display: flex;
        // justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        text-align: center;
        padding: 11px 0px 11px 20px;
        font-size: 16px;
        line-height: 25px;
        color: #000;
        font-weight: 700;
        text-align: center;

        img {
            width: 8px;
            height: 16px;
            margin-right: 36%;
        }
    }
    .lists{
        height: 400px;
        overflow-y: auto;
    }
    .gifts {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .gift-list {
        font-size: 13px;
        line-height: 18px;
        color: #333333;
        margin: 0 20px;
        padding: 14px 0;
        box-sizing: border-box;
        border-bottom: 1px solid #EEEEEE;
        display: flex;
        flex-direction: column;
        position: relative;

        .txt {
            color: #FE2C55;
        }

        .time {
            color: #666666;
            font-size: 11px;
            line-height: 15px;
            margin-top: 8px;

        }

        .number {
            font-size: 16px;
            color: #FE2C55;
            font-weight: 600;
            position: absolute;
            bottom: 10px;
            right: 0;

        }
    }

    .noData {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        line-height: 20px;
        color: #999;

        img {
            width: 300px;
            height: 300px;
        }

    }
         .item {
             width: 90%;
             margin: 0 auto;
             display: flex;
             flex-direction: column;
             justify-content: center;
             align-items: flex-start;
             margin-bottom: 10px;
             box-sizing: border-box;
             position: relative;
    
             .top {
                 width: 100%;
                 display: flex;
                 justify-content: flex-start;
                 align-items: center;
                 margin-bottom: 10px;
    
                 img {
                     width: 28px;
                     height: 28px;
                     border-radius: 50%;
                     margin-right: 10px;
                 }
    
                 p {
                     display: flex;
                     flex-direction: column;
                     justify-content: flex-start;
                     align-items: flex-start;
    
                     span {
                         color: #b3b3b3;
                         font-size: 13px;
                         margin: 2px 5px 2px 0;
                     }
                 }
    
                 span {
                     font-size: 14px;
                     line-height: 20px;
                     color: #333;
                 }
             }
    
             .content {
                 font-size: 13px;
                 color: #333;
                 line-height: 18px;
    
                 .name {
                     font-weight: 600;
                 }
    
                 margin: 16px 0 8px 0;
             }
    
             .flex {
                 display: flex;
                 align-items: center;
             }
    
             .imgs {
                 width: 124px;
                 height: 86px;
                 border: 1px solid #EDEDED;
                 border-radius: 10px;
                 margin-right: 12px;
             }
    
             .times {
                 color: #666666;
                 font-size: 11px;
                 line-height: 15px;
                 position: absolute;
                 top: 8%;
                 right: 0;
    
             }
    
             .bottom {
                 background-color: #fff;
                 padding: 10px;
                 text-align: justify;
                 font-size: 14px;
                 border-radius: 5px;
                 white-space: pre-wrap;
             }
    
             .bottoms {
                 width: 100%;
                 display: flex;
                 align-items: center;
                 justify-content: space-between;
             }
    
             .type {
                 width: 84px;
                 height: 25px;
                //  background: #FFF7E9;
                 border-radius: 4px;
                //  color: #D79B00;
                 font-size: 12px;
                 line-height: 17px;
                 text-align: center;
                 line-height: 25px;
             }
    
             .like {
                 font-size: 14px;
                 line-height: 17px;
                 color: #333;
                 display: flex;
                 align-items: center;
                 justify-content: center;
    
                 img {
                     width: 18px;
                     height: 18px;
                     margin-right: 6px;
                 }
             }
         }
}
</style>